(function () {
  function initTabs(root) {
    if (root.dataset.sqpTabsReady === 'true') return;
    root.dataset.sqpTabsReady = 'true';

    var tabs = root.querySelectorAll('[data-sqp-tab]');
    var panels = root.querySelectorAll('[data-sqp-panel]');
    if (!panels.length) return;

    function activate(id) {
      if (tabs.length) {
        tabs.forEach(function (tab) {
          var isActive = tab.getAttribute('data-sqp-tab') === id;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });
      }

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-sqp-panel') === id;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-sqp-tab'));
      });
    });

    var defaultTab = root.getAttribute('data-sqp-default-tab') || 'pay';
    var hasDefault = false;

    panels.forEach(function (panel) {
      if (panel.getAttribute('data-sqp-panel') === defaultTab) {
        hasDefault = true;
      }
    });

    activate(hasDefault ? defaultTab : panels[0].getAttribute('data-sqp-panel'));
  }

  function boot() {
    document.querySelectorAll('[data-sqp-tabs-root]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
